import React, { FunctionComponent, CSSProperties, useMemo } from 'react';
import { useParams } from "react-router-dom";
import { useSelector } from 'react-redux';

import { Article, RootStore } from '../app/types';
import { ArticleNavItem } from './ArticleNavItem';

const navListStyle: CSSProperties = {
    marginTop: "5px",
    paddingBottom: "5px",
    color: "white",
    width: "100%",
    whiteSpace: "nowrap",
    overflowX: "scroll",
    overflowY: "hidden",
};

export const ArticleHNavList: FunctionComponent = () => {
    const { articleID } = useParams();
    const articleIdNum = parseInt(articleID);

    const articles = useSelector((state: RootStore) => state.articles);

    const navArticles = useMemo(() => {
        const article = articles.find((a: Article) => a.ID === articleIdNum);
        if (!article) return null;
        return articles
            .filter((a: Article) => a.collectionID === article.collectionID)
            .sort((a, b) => a.orderIndex - b.orderIndex);
    }, [articles, articleIdNum]);

    return (
        <div style={navListStyle}>
            {navArticles && navArticles.map((article, idx) => {
                return <ArticleNavItem key={"article-"+idx} article={article} />
            })}
        </div>
    );
}
